/**
 * 状态徽章组件 — 基于 MUI Chip。
 * 支持 success / warning / error / info 四种语义色。
 * 也支持自定义颜色（用于投放状态等特殊映射）。
 */
import { Chip } from "@mui/material";

export type BadgeVariant = "success" | "warning" | "error" | "info" | "default";

export interface BadgeProps {
  /** 显示文字。 */
  label: string;
  /** 预设语义色。 */
  variant?: BadgeVariant;
  /** 自定义文字色（优先于 variant）。 */
  color?: string;
  /** 自定义背景色（优先于 variant）。 */
  bgColor?: string;
  /** 尺寸。 */
  size?: "small" | "medium";
}

/** 预设颜色映射。 */
const VARIANT_MAP: Record<BadgeVariant, { color: string; bg: string }> = {
  success: { color: "success.main", bg: "semanticBg.success" },
  warning: { color: "warning.main", bg: "semanticBg.warning" },
  error: { color: "error.main", bg: "semanticBg.error" },
  info: { color: "info.main", bg: "semanticBg.info" },
  default: { color: "text.secondary", bg: "semanticBg.neutral" },
};

export default function Badge({
  label,
  variant = "default",
  color,
  bgColor,
  size = "small",
}: BadgeProps) {
  const preset = VARIANT_MAP[variant];
  const finalColor = color || preset.color;
  const finalBg = bgColor || preset.bg;

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        color: finalColor,
        bgcolor: finalBg,
        fontWeight: 500,
        height: size === "small" ? 22 : 26,
        fontSize: size === "small" ? 11 : 12,
        borderRadius: "11px",
        "& .MuiChip-label": { px: 1 },
      }}
    />
  );
}
